export default __webpack_public_path__ + "static/media/alert.802aa680.svg";